import { useLocation, useNavigate } from 'react-router-dom';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';

const INTEGRATION_TABS = [
  { key: '/integration/configs', labelKey: 'integration.configs_title' },
  { key: '/integration/oauth-tokens', labelKey: 'integration.oauth_tokens_title' },
  { key: '/integration/webhooks', labelKey: 'integration.webhooks_title' },
  { key: '/integration/webhook-events', labelKey: 'integration.webhook_events_title' },
];

export default function IntegrationNav() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const activeKey = INTEGRATION_TABS.find(
    (tab) => location.pathname.startsWith(tab.key)
  )?.key ?? '/integration/configs';

  return (
    <Tabs
      activeKey={activeKey}
      onChange={(key) => navigate(key)}
      items={INTEGRATION_TABS.map((tab) => ({
        key: tab.key,
        label: t(tab.labelKey),
      }))}
      style={{ marginBottom: 16 }}
    />
  );
}
